/* global axios */
import ApiClient from '../ApiClient';

// Masifi: Panel de Control (brand-resellers-design.md §4). Account-scoped: la cuenta de la URL es solo el ancla de
// sesión; el backend decide el alcance (Masifi::Console::Scope).
class MasifiConsoleAPI extends ApiClient {
  constructor() {
    super('masifi/console', { accountScoped: true });
  }

  me() {
    return axios.get(`${this.url}/me`);
  }

  summary() {
    return axios.get(`${this.url}/summary`);
  }

  accounts(params = {}, { signal } = {}) {
    return axios.get(`${this.url}/accounts`, { params, signal });
  }

  account(id) {
    return axios.get(`${this.url}/accounts/${id}`);
  }

  createAccount(payload) {
    return axios.post(`${this.url}/accounts`, payload);
  }

  updateAccount(id, payload) {
    return axios.patch(`${this.url}/accounts/${id}`, payload);
  }

  suspend(id, payload) {
    return axios.post(`${this.url}/accounts/${id}/suspend`, payload);
  }

  reactivate(id) {
    return axios.post(`${this.url}/accounts/${id}/reactivate`);
  }

  resendInvitation(id, userId) {
    return axios.post(`${this.url}/accounts/${id}/resend_invitation`, {
      user_id: userId,
    });
  }

  auditEvents(params = {}, { signal } = {}) {
    return axios.get(`${this.url}/audit_events`, { params, signal });
  }

  brands(params = {}, { signal } = {}) {
    return axios.get(`${this.url}/brands`, { params, signal });
  }

  // ownerKey: 'platform' | 'account-<id>' | 'reseller-<id>' (RA2-16).
  updateBrand(ownerKey, payload) {
    return axios.patch(`${this.url}/brands/${ownerKey}`, payload);
  }

  // P3: "Probar envío" llega SIEMPRE al correo de quien prueba (el backend ignora cualquier destinatario, A-3).
  testBrandMail(ownerKey, payload = {}) {
    return axios.post(`${this.url}/brands/${ownerKey}/mail_test`, payload);
  }

  verifyBrandSender(ownerKey, payload) {
    return axios.post(
      `${this.url}/brands/${ownerKey}/sender_verification`,
      payload
    );
  }

  verifyCnameTarget(ownerKey) {
    return axios.post(
      `${this.url}/brands/${ownerKey}/cname_target_verification`
    );
  }

  renameDomain(id, payload) {
    return axios.post(`${this.url}/domains/${id}/rename`, payload);
  }

  domains(params = {}, { signal } = {}) {
    return axios.get(`${this.url}/domains`, { params, signal });
  }

  createDomain(payload) {
    return axios.post(`${this.url}/domains`, payload);
  }

  reverifyDomain(id) {
    return axios.post(`${this.url}/domains/${id}/reverify`);
  }

  reprovisionDomain(id) {
    return axios.post(`${this.url}/domains/${id}/reprovision`);
  }

  makePrimaryDomain(id) {
    return axios.post(`${this.url}/domains/${id}/primary`);
  }

  removeDomain(id, { confirm = false } = {}) {
    return axios.delete(`${this.url}/domains/${id}`, { params: { confirm } });
  }

  cloudflare() {
    return axios.get(`${this.url}/cloudflare`);
  }

  refreshCloudflare() {
    return axios.post(`${this.url}/cloudflare/refresh`);
  }

  applyCloudflareItem(key) {
    return axios.post(`${this.url}/cloudflare/items/${key}/apply`);
  }

  // Agencias (R2.6, solo raíz). Toda respuesta de una agencia viene envuelta en { reseller } (I-15).
  resellers(params = {}, { signal } = {}) {
    return axios.get(`${this.url}/resellers`, { params, signal });
  }

  reseller(id, { signal } = {}) {
    return axios.get(`${this.url}/resellers/${id}`, { signal });
  }

  createReseller(payload) {
    return axios.post(`${this.url}/resellers`, payload);
  }

  updateReseller(id, payload) {
    return axios.patch(`${this.url}/resellers/${id}`, payload);
  }

  suspendReseller(id, payload) {
    return axios.post(`${this.url}/resellers/${id}/suspend`, payload);
  }

  reactivateReseller(id) {
    return axios.post(`${this.url}/resellers/${id}/reactivate`);
  }

  handover(id) {
    return axios.get(`${this.url}/resellers/${id}/handover`);
  }

  handoverOauthNotice(id) {
    return axios.post(`${this.url}/resellers/${id}/handover/oauth_notice`);
  }

  releaseReseller(id) {
    return axios.post(`${this.url}/resellers/${id}/handover/release`);
  }

  // Equipo de una agencia (R2.7): { members, meta }.
  members(resellerId, params = {}, { signal } = {}) {
    return axios.get(`${this.url}/resellers/${resellerId}/members`, {
      params,
      signal,
    });
  }

  createMember(resellerId, payload) {
    return axios.post(`${this.url}/resellers/${resellerId}/members`, payload);
  }

  updateMember(resellerId, id, payload) {
    return axios.patch(
      `${this.url}/resellers/${resellerId}/members/${id}`,
      payload
    );
  }

  removeMember(resellerId, id) {
    return axios.delete(`${this.url}/resellers/${resellerId}/members/${id}`);
  }
}

export default new MasifiConsoleAPI();
